module.exports = __webpack_public_path__ + "img/zalo-logo.7d3c8e05.png";